import {
  SEND_CONFIRMATION_EMAIL_SUCCESS,
  SEND_CONFIRMATION_EMAIL_ERROR,
  CONFIRM_CODE_SUCCESS,
  SIGN_UP_SUCCESS,
  SIGN_UP_ROOTIE_SUCCESS,
  APPSUMO_SIGN_UP_SUCCESS,
  CLEAR_SIGN_UP_ERRORS,
} from './type'
import { set as setCookie } from 'es-cookie'
import { getCookieOptions, getSessionCookieOptions } from '../../utils/cookie-options'

//eslint-disable-next-line
export default function (state = {}, action) {
  const { payload } = action

  switch (action.type) {
    case SEND_CONFIRMATION_EMAIL_ERROR:
      return {
        ...state,
        emailInvalidError: payload.error?.emailInvalid || false,
        userExistsError: payload.error?.userExists || false,
      }
    case SEND_CONFIRMATION_EMAIL_SUCCESS:
      const { email } = payload
      setCookie('email', email.email, getSessionCookieOptions())

      window.open('/checkEmail', '_top')
      return { ...state, email, emailInvalidError: false, userExistsError: false }
    case CONFIRM_CODE_SUCCESS:
      const { data } = payload
      setCookie('confirmCode', data.data, getSessionCookieOptions())

      window.location.href = '/signup/' + data.data

      return { ...state, data }
    case SIGN_UP_SUCCESS:
      const { entity } = payload
      setCookie('token', entity.accessToken, getCookieOptions())
      setCookie('refreshToken', entity.refreshToken, getCookieOptions())
      setCookie('userId', entity.userId, getCookieOptions())

      window.location.href = '/purpose'

      return { ...state, entity }
    case SIGN_UP_ROOTIE_SUCCESS:
      setCookie('token', payload.entity.token, getSessionCookieOptions())

      window.location.href = '/'

      return { ...state, entity }
    case CLEAR_SIGN_UP_ERRORS:
      return {
        ...state,
        emailInvalidError: false,
        userExistsError: false,
      }
    default:
      return state

    case APPSUMO_SIGN_UP_SUCCESS:
      setCookie('token', payload.entity.accessToken, getSessionCookieOptions())
      setCookie('refreshToken', payload.entity.refreshToken, getSessionCookieOptions())
      setCookie('userId', payload.entity.userId, getSessionCookieOptions())
      window.location.href = '/'

      return { ...state, entity }
  }
}
